import MaterialsApi from '@/api/materials';

export default {
  namespaced: true,
  state: {
    materials: [],
    appointments: [],
    types: [],
    levels: [],
  },

  mutations: {
    SET_MATERIALS(state, val) {
      state.materials = val;
    },
    SET_APPOINTMENTS(state, val) {
      state.appointments = val;
    },
    SET_TYPES(state, val) {
      state.types = val;
    },
    SET_LEVELS(state, val) {
      state.levels = val;
    },
  },
  actions: {
    async getMaterials({ commit }) {
      try {
        const materials = await MaterialsApi.getModels();
        commit('SET_MATERIALS', materials.data);
        return materials;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async getAppointments({ commit }) {
      try {
        const appointments = await MaterialsApi.getAppointments();
        if (appointments.status === 200) {
          commit('SET_APPOINTMENTS', appointments.data);
          return appointments;
        }
        throw new Error('could set appointments');
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async getTypes({ commit }) {
      try {
        const types = await MaterialsApi.getTypes();
        if (types.status === 200) {
          commit('SET_TYPES', types.data);
          return types;
        }
        throw new Error('could set types');
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async getLevels({ commit }) {
      try {
        const levels = await MaterialsApi.getLevels();
        if (levels.status === 200) {
          commit('SET_LEVELS', levels.data);
          return levels;
        }
        throw new Error('could set levels');
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },

};
